import React, { useRef } from "react";

// React wrapper for Om Design System Icon web component
const OmIcon = React.forwardRef(({ 
  children,
  name,
  size,
  color,
  slot,
  ...props 
}, ref) => {
  const elementRef = useRef(null);

  return (
    <omk-icon
      ref={(el) => {
        elementRef.current = el;
        if (ref) {
          if (typeof ref === 'function') {
            ref(el);
          } else {
            ref.current = el;
          }
        }
      }}
      name={name}
      size={size}
      color={color}
      slot={slot}
      {...props}
    >
      {children}
    </omk-icon>
  );
});

OmIcon.displayName = 'OmIcon';

export default OmIcon;
